var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrandma({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_399",
    x: 0,
    y: 0,
    width: 73,
    height: 73,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29213",
    "data-name": "Group 29213",
    transform: "translate(212 11197)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -212, -11197)",
    filter: "url(#Ellipse_399)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_399-2",
    "data-name": "Ellipse 399",
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28924",
    "data-name": "Group 28924",
    transform: "translate(-4310.536 -5152.723)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49959",
    "data-name": "Path 49959",
    d: "M189.241,5.688a5.267,5.267,0,0,0-5.267,5.267h10.533A5.267,5.267,0,0,0,189.241,5.688Z",
    transform: "translate(3946.019 -6034.965)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49960",
    "data-name": "Path 49960",
    d: "M190.1,5.759a5.265,5.265,0,0,0-6.125,5.2h1.716A5.267,5.267,0,0,1,190.1,5.759Z",
    transform: "translate(3946.019 -6034.965)",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49961",
    "data-name": "Path 49961",
    d: "M138.877,38.532a10.923,10.923,0,0,0-9.929,0,5.225,5.225,0,0,0-.228.88l-.074.878h10.391V39.077A5.227,5.227,0,0,0,138.877,38.532Zm3.744,33.3a.916.916,0,0,0,.923-.906v-.009a9.632,9.632,0,0,0-19.263,0v.009a.916.916,0,0,0,.923.906Z",
    transform: "translate(4001.347 -6064.302)",
    fill: "#f8404a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49962",
    "data-name": "Path 49962",
    d: "M126.255,375.121v-.009a9.6,9.6,0,0,1,8.644-9.526,9.8,9.8,0,0,0-.987-.05,9.6,9.6,0,0,0-9.632,9.575v.009a.916.916,0,0,0,.923.906h1.974A.916.916,0,0,1,126.255,375.121Z",
    transform: "translate(4001.347 -6368.5)",
    fill: "#b6333b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49963",
    "data-name": "Path 49963",
    d: "M130.31,71.755c.877-6.174-1.048-9.486-3.461-11.259a13.2,13.2,0,0,0-7.069-2.005,9.205,9.205,0,0,0-6.711,2.269,4.671,4.671,0,0,0-.668.711c-4.819,2.6-3.2,8.653-2.711,10.138V73.37h20.545Z",
    transform: "translate(4015.479 -6083.902)",
    fill: "#fefefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49964",
    "data-name": "Path 49964",
    d: "M114.3,61.47a4.67,4.67,0,0,1,.668-.711,8.913,8.913,0,0,1,5.646-2.247c-.521-.033-.836-.021-.836-.021a9.205,9.205,0,0,0-6.711,2.269,4.671,4.671,0,0,0-.668.711c-4.819,2.6-3.2,8.653-2.711,10.138V73.37h1.9V71.608C111.1,70.123,109.483,64.067,114.3,61.47Z",
    transform: "translate(4015.479 -6083.902)",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49965",
    "data-name": "Path 49965",
    d: "M371.927,239.375a1.939,1.939,0,0,0-1.907.767l.053,3.488a1.678,1.678,0,0,0,.794.429,2.448,2.448,0,0,0,1.06-4.685Z",
    transform: "translate(3773.577 -6251.528)",
    fill: "#ffc073"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49966",
    "data-name": "Path 49966",
    d: "M97.138,240.375a2.448,2.448,0,0,0,1.06,4.684,1.678,1.678,0,0,0,.794-.429l.053-3.488A1.939,1.939,0,0,0,97.138,240.375Z",
    transform: "translate(4027.864 -6252.455)",
    fill: "#ffd7a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49967",
    "data-name": "Path 49967",
    d: "M96.622,243.151a2.233,2.233,0,0,1,1.317-2.753,1.671,1.671,0,0,0-.8-.02,2.448,2.448,0,0,0,1.06,4.684l.076-.02A2.468,2.468,0,0,1,96.622,243.151Z",
    transform: "translate(4027.864 -6252.458)",
    fill: "#ffc073"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49968",
    "data-name": "Path 49968",
    d: "M147.724,171.143c-.229,0-.367,8.6-.233,8.789a2.481,2.481,0,0,0,4.232.037.281.281,0,0,0-.226-.447Zm9.985-.834a11.632,11.632,0,0,1-4.91-5.886c-3.906,4.558-11.267,5.886-11.267,5.886s-2.715,8.809,8.089,8.886C160.424,179.117,157.709,170.309,157.709,170.309Z",
    transform: "translate(3985.639 -6182.093)",
    fill: "#ffd7a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49969",
    "data-name": "Path 49969",
    d: "M151.082,249.8c-10.8-.077-8.089-8.886-8.089-8.886l-1.462.292s-2.715,8.809,8.089,8.886a14.013,14.013,0,0,0,3.563-.435A16.368,16.368,0,0,1,151.082,249.8Zm-2.768.591-.488,0a.333.333,0,0,0-.268.534,2.624,2.624,0,0,0,2.062,1.113,2.263,2.263,0,0,0,.548-.068A3.006,3.006,0,0,1,148.314,250.392Z",
    transform: "translate(3985.64 -6252.992)",
    fill: "#ffc073"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_28921",
    "data-name": "Group 28921",
    transform: "translate(4128.537 -6009.494)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_426",
    "data-name": "Ellipse 426",
    cx: 1.429,
    cy: 1.42,
    rx: 1.429,
    ry: 1.42,
    fill: "#fdac7c"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_427",
    "data-name": "Ellipse 427",
    cx: 1.429,
    cy: 1.42,
    rx: 1.429,
    ry: 1.42,
    transform: "translate(10.589)",
    fill: "#fdac7c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_49970",
    "data-name": "Path 49970",
    d: "M188.161,42.223a8.66,8.66,0,0,0-2.1.836,5.229,5.229,0,0,0-.161.55v1.005a8.112,8.112,0,0,1,1.662-.754A5.226,5.226,0,0,1,188.161,42.223Z",
    transform: "translate(3944.233 -6068.828)",
    fill: "#b6333b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49971",
    "data-name": "Path 49971",
    d: "M234.688,304.335a.219.219,0,0,0-.219.219c0,.286-.585.606-1.368.606s-1.368-.32-1.368-.606a.219.219,0,0,0-.439,0c0,.6.777,1.044,1.807,1.044s1.807-.449,1.807-1.044A.219.219,0,0,0,234.688,304.335Z",
    transform: "translate(3902.159 -6311.774)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49973",
    "data-name": "Path 49973",
    d: "M183.494,227.7a.809.809,0,0,1,1.08,0,.219.219,0,1,0,.292-.327,1.248,1.248,0,0,0-1.664,0,.219.219,0,1,0,.292.327Zm-9.444,2.054a.292.292,0,1,0,.421.406c1.035-1.076,2.884.413,2.9.428a.293.293,0,0,0,.371-.452C177.651,230.061,175.458,228.292,174.049,229.756Zm8.139.381a.293.293,0,0,0,.371.452c.019-.015,1.867-1.5,2.9-.428a.292.292,0,1,0,.421-.406C184.473,228.292,182.281,230.061,182.188,230.137ZM177.4,231.62c-.058.058-1.42,1.446-.957,2.691a.219.219,0,0,0,.411-.153c-.364-.982.845-2.217.857-2.229a.219.219,0,0,0-.311-.309Z",
    transform: "translate(3955.294 -6240.147)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrandma);
export default __webpack_public_path__ + "static/media/Grandma.b23808ff248cb02340074ec2a9df8675.svg";
export { ForwardRef as ReactComponent };